import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  MenuGroup,
  Menu,
  MenuTrigger,
  MenuList,
  MenuItem,
  MenuPopover,
  MenuGroupHeader,
  FluentProvider,
  webLightTheme,
  makeStyles,
} from '@fluentui/react-components';
import CopilotIcon from './media/sparkle.svg';
import CopilotIconSelected from './media/sparkle-selected.svg';
import TryBackgroundIcon from './media/try-background.svg';

const padding = '6px';
const useInlineCopilotUIStyles = makeStyles({
  image: {
    paddingRight: '4px',
  },
  popover: {
    paddingTop: padding,
    paddingBottom: padding,
    paddingLeft: padding,
    paddingRight: padding,
  },
  groupHeader: {
    paddingTop: padding,
    paddingBottom: padding,
    paddingLeft: padding,
    paddingRight: padding,
  },
  menuItem: {
    paddingTop: padding,
    paddingBottom: padding,
    paddingLeft: padding,
    paddingRight: padding,
  },
});

export const SparkleMenuButton = (props) => {
  const {
    imageItem, i18n, baseImageId, onChangeBackgroundScene, onMeuOpenChange,
  } = props;
  const classes = useInlineCopilotUIStyles();

  return (
    <FluentProvider theme={webLightTheme}>
      <Menu className="sparkle-menu" closeOnScroll onOpenChange={onMeuOpenChange}>
        <MenuTrigger>
          {triggerprops => (
            <button {...triggerprops} className="copilot-button">
              <img src={CopilotIconSelected} className="active" alt={i18n.getString(_TL_('Ads Copilot'))} />
              <img src={CopilotIcon} className="passive" alt={i18n.getString(_TL_('Ads Copilot'))} />
            </button>
          )}
        </MenuTrigger>
        <MenuPopover className={classnames('copilot-menu-popover', classes.popover)}>
          <MenuList>
            <MenuGroup>
              <MenuGroupHeader className={classes.groupHeader}>{i18n.getString(_TL_('Copilot can assist you'))}</MenuGroupHeader>
              <MenuItem onClick={onChangeBackgroundScene} className={classnames('copilot-different-background-item', classes.menuItem)} data-imageid={baseImageId} disabled={!!imageItem.disableEdit}>
                <img src={TryBackgroundIcon} alt={i18n.getString(_TL_('Change to a new background'))} className={classes.image} />
                <span>{i18n.getString(_TL_('Change to a new background'))}</span>
              </MenuItem>
            </MenuGroup>
          </MenuList>
        </MenuPopover>
      </Menu>
    </FluentProvider>
  );
};

SparkleMenuButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onChangeBackgroundScene: PropTypes.func.isRequired,
  baseImageId: PropTypes.string.isRequired,
  imageItem: PropTypes.shape({
    disableEdit: PropTypes.bool.isRequired,
  }).isRequired,
  onMeuOpenChange: PropTypes.func.isRequired,
};

